import { makeAutoObservable } from 'mobx';
import { TGetFilterResponse, TGetHotelResponse, TRoomQuotation } from '@features/hotel/types';

export class HotelStore {
  showFilter = false;
  filterData: TGetFilterResponse = {} as TGetFilterResponse;
  hotelDetail: TGetHotelResponse = {} as TGetHotelResponse;
  selectedRoomQuotations: TRoomQuotation[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setShowFilter = (show: boolean) => {
    this.showFilter = show;
  };

  setFilterData = (filterData: TGetFilterResponse) => {
    this.filterData = filterData;
  };

  setHotelDetail = (detail: TGetHotelResponse) => {
    this.hotelDetail = detail;
  };

  toggleRoomQuotation = (roomQuotation: TRoomQuotation) => {
    const existingIndex = this.selectedRoomQuotations.findIndex(
      item =>
        item.roomSession === roomQuotation.roomSession &&
        item.selectedRateOption?.rateSession === roomQuotation.selectedRateOption?.rateSession
    );

    if (existingIndex !== -1) {
      this.selectedRoomQuotations.splice(existingIndex, 1);
    } else {
      this.selectedRoomQuotations.push(roomQuotation);
    }
  };

  removeRoomQuotation = (roomSession: string, rateSession: string) => {
    this.selectedRoomQuotations = this.selectedRoomQuotations.filter(
      item =>
        !(item.roomSession === roomSession && item.selectedRateOption?.rateSession === rateSession)
    );
  };

  clearAllRoomQuotations = () => {
    this.selectedRoomQuotations = [];
  };
}

const hotelStore = new HotelStore();

export default hotelStore;
